import { Trans } from "@lingui/react/macro";
import { UserAppointmentMessageScheduler } from "@/Components/MessageScheduler";
import { LuMessageSquarePlus } from "react-icons/lu";
import {
  Button,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@heroui/react";
import { LimeModal } from "@/Components/NextBase/LimeModal";

export const MessageModal = ({
  userAppointmentId,
}: {
  userAppointmentId: number;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        onPress={onOpen}
        variant="light"
        color="primary"
        startContent={<LuMessageSquarePlus size={16} />}
        size="sm"
      >
        <Trans>Ustvari novo</Trans>
      </Button>
      <LimeModal isOpen={isOpen} onClose={onClose} isDismissable={false}>
        <ModalContent>
          <ModalHeader>
            <Trans>Načrtuj sporočilo</Trans>
          </ModalHeader>
          <ModalBody>
            <UserAppointmentMessageScheduler
              userAppointmentId={userAppointmentId}
              onClose={close}
            ></UserAppointmentMessageScheduler>
          </ModalBody>
        </ModalContent>
      </LimeModal>
    </>
  );
};
